import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect, useDispatch } from 'react-redux'
import { Col, Row } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import { wallAct } from '../../../../redux/actions'
import LikeButton from 'components/LikeButton'
import MessageReaction from 'components/MessageReaction'
import ChatInputText from 'components/ChatInputText'
import { getDateTimeFromNow } from 'utils/helpers'
import composerActions from '../../../../redux/actions/conversations/composerAct'

const ChatChannelWallMessagesPlugins = ({ sendEvent, user, node }) => {
  const [comment, setComment] = useState('')
  const [showReply, setShowReply] = useState(false)
  const onChangeComment = (value) => setComment(value)
  const dispatch = useDispatch()

  const addEventToWall = async (wallNodeType, eventType, messageInfo = null) => {
    try {
      await dispatch(composerActions.sendMessage(
        {
          message: messageInfo || ' ',
          attachments: [],
          checkTime: true,
          tag: null,
          buttons: null,
          vaSuggestion: null,
          nodeId: node._id,
          eventType: eventType,
        },
        null
      ))
    } catch (error) {
      console.error(error)
    }


  }
  const sendComment = () => {
    addEventToWall('operator', 'COMMENT', comment)
    setShowReply(false)
  }
  const sendEmoji = (emoji) => addEventToWall('operator', `REACT_${emoji}`)
  const sendLike = () => addEventToWall('operator', 'THUMB')

  const numbersOfComments = () => {
    const comments = node.actionSummaryList.find((action) => action.type === 'COMMENT')
    return comments ? comments.count : 0
  }
  return (
    <>
      <div className='date-time'>
        <i className='fa fa-clock-o' />
        {getDateTimeFromNow(node.createdAt, user.locale)}
      </div>

      <Row className='message-plugins_comments like-response'>
        <Col sm='4' className='pr-1'>
          <LikeButton actionSummaryList={node.actionSummaryList} onAddLike={sendLike} />
        </Col>
        <Col sm='4' className='text-center px-1'>
          <div className={' thumb-like-content'}>
            <span className='thumbs-like-button'>
              <i className='pl-1 fa fa-comments fa-2x' aria-hidden='true' />
            </span>
            <span className='thumb-like-text'>{numbersOfComments()}</span>
            <span>{I18n.t('message_comments')}</span>
          </div>
        </Col>
        <Col sm='4' className='text-center px-1 reply-message d-flex justify-content-end align-items-baseline'>
          <div className='reply-btn' onClick={() => setShowReply(!showReply)}>
            <i className='fa fa-reply reply_msg-margin' />
            {I18n.t('message_reply')}
          </div>
        </Col>
      </Row>

      {/* EMOJI */}
      <Row>
        <Col>
          <MessageReaction user={user} operator={user.operator} actionSummaryList={node.actionSummaryList} onSelectEmoji={sendEmoji} />
        </Col>
      </Row>

      {showReply && <ChatInputText onChangeComment={onChangeComment} sendComment={sendComment} />}
    </>
  )
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      sendEvent: wallAct.sendEvent,
    },
    dispatch
  )

export default connect(null, mapDispatchToProps)(ChatChannelWallMessagesPlugins)
